var Midttrafik2016 = Midttrafik2016 || {}

Midttrafik2016.newsListView = new function () {
    var self = this
    var page = parseInt($('#page-counter').attr('data-page'))
    if (page == NaN || page == "" || page == null || page == undefined || page.toString() == "NaN") {
        page = 0;
    }
//    var today = new Date()
//    var monthNumber = today.getMonth() + 1
//    var yearNumber = today.getFullYear()

    var delay = (function () {
        var timer = 0
        return function (callback, ms) {
            clearTimeout(timer)
            timer = setTimeout(callback, ms)
        }
    })()
    this.init = function () {
//        self.loadNavClick()
        if ($('#newsListView').length) {
            self.loader()
            self.loadMore()
            self.loadNews(page, false)
        }
    }

    this.loader = function () {
        $('#newsListView').html('<li class="loader"><div id="fountainTextG"><div id="fountainTextG_1" class="fountainTextG">m</div><div id="fountainTextG_2" class="fountainTextG">i</div><div id="fountainTextG_3" class="fountainTextG">d</div><div id="fountainTextG_4" class="fountainTextG">t</div><div id="fountainTextG_5" class="fountainTextG">r</div><div id="fountainTextG_6" class="fountainTextG">a</div><div id="fountainTextG_7" class="fountainTextG">f</div><div id="fountainTextG_8" class="fountainTextG">i</div><div id="fountainTextG_9" class="fountainTextG">k</div></div></li>')
        $('.loader').fadeIn()
    }

    this.loadMore = function () {
        $('#nextPageBtn').on('click', function () {
            var currentPage = parseInt($('#page-counter').attr('data-page'))
            $('#page-counter').attr('data-page', currentPage + 1)

            self.loadNews(currentPage + 1, true)
        })
    }

//    this.loadNavClick = function () {
//        $('.navNewsMonth').on('click', function (e) {
//            e.preventDefault()
//            monthNumber = $(this).data('month')
//            yearNumber = $(this).data('year')
//            self.loadNews(page, false)
//        })
//    }

    this.loadNews = function (page, packeryLayout) {
        var nlEle = $('#newsListView');

        var nodeId = nlEle.data('nodeid')
        var ipp = nlEle.data('ipp') // Items Per Page
        var queryYear = nlEle.data('year')
        var queryMonth = nlEle.data('month')

        var filterValues = JSON.stringify({
            'NodeId': nodeId, // Int
            'NumberOfItemsPerPage': ipp, // Int
            'Page': page, // Int
            'MonthNumber': queryMonth, //Int or null
            'YearNumber': queryYear, //Int or null
        })

        $.ajax({
            url: '/settings/newslistview/',
            type: 'POST',
            cache: false,
            contentType: 'html/text; charset=utf-8',
            dataType: 'html',
            data: filterValues,
            success: function (data) {
                var dataObj = $(data)
                var nextPageBtn = $('#nextPageBtn')
                if (page > 0) {
                    dataObj.appendTo($('#newsListView')).hide().fadeIn(100)
                } else {
                    $('#newsListView').html(data).hide().fadeIn(100)
                    $('#page-counter').attr('data-page', 0)
                }

                var hasNextPage = $(dataObj.filter('.hasNextPage')[0]).val()
                if (hasNextPage == 'False') {
                    nextPageBtn.hide()
                } else {
                    nextPageBtn.show()
                }
            },
            error: function (data, errorThrown) {
                $('#newsListView').html('<div class="ajax-content error-msg">Der er desv&aelig;rre sket en fejl </br></br>' + data + ' ' + errorThrown + '</br></br> <button class="btn btn-blue light" onclick="location.reload();"> Genindl&aelig;s siden </button></div>')
            }
        })
    }

//    // from http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
//    function getParameterByName(name, url) {
//        if (!url) url = window.location.href;
//        name = name.replace(/[\[\]]/g, "\\$&");
//        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
//            results = regex.exec(url);
//        if (!results) return null;
//        if (!results[2]) return '';
//        return decodeURIComponent(results[2].replace(/\+/g, " "));
//    }

    $(".search-form").submit(function (e) {
        e.preventDefault();
        $(".search-form__input").blur();
    })
}()
